import SessionTelemetry from '../store/schema/SessionTelemetry';

export default function updateTelemetryForSessionWithExplicitFeedback(
    sessionTelemetry: SessionTelemetry,
    positiveFeedback: boolean
) {
    if (positiveFeedback) {
        sessionTelemetry.satReported
            ? sessionTelemetry.satReported++
            : (sessionTelemetry.satReported = 1);
    } else {
        sessionTelemetry.dsatReported
            ? sessionTelemetry.dsatReported++
            : (sessionTelemetry.dsatReported = 1);
    }
}
